import compose from 'lodash/flowRight'
import { connect } from 'react-redux'

import { withRenderToasters } from 'utils/hoc/withRenderToasters'
import withRouterCustom from 'utils/hoc/withRouterCustom'
import { withLaunchDarkly } from 'utils/sdks/launchDarkly.v2'
import { withMixpanel } from 'utils/sdks/mixpanel'
import { toGlobalId } from 'utils/transformations/graphql'

import {
  withConnectedProviders,
  withInvoicesStatus,
} from 'payments/payments.queries'
import {
  allowInvoiceRetailers,
  canAssignOrdersToNewConnections,
  getAccountId,
  getAccountProfileName,
  isAccountTypeBrand,
  isAddEditEventsRestricted,
  isCancelStylesRestricted,
  isLiteRetailer,
  isMarkOrderExportedAllowed,
  isSetToReExportExportOrderAllowed,
  restrictMergeOrders,
} from 'store/currentUser/selectors'
import { setOrdersModal } from 'store/modal/actions'
import {
  renderErrorNotification,
  renderNotification,
  renderSuccessNotification,
} from 'store/notificationHandler/actions'
import {
  changePageSize,
  resetSelectedOrders,
  setMergeOrderMessages,
  toggleCheckMergeOrders,
  toggleDisplayDivisionColumn,
  toggleMergeOrderModal,
  toggleOrder,
  toggleSelectOrdersOnPage,
} from 'store/orderList/actions'
import {
  allOrdersAreSelected,
  filterSelectedOrders,
  getSelectedOrdersIds,
  isMergeOrderModalOpen,
  isOrderSelected,
  mergeOrderMessages,
  shouldCheckMergeOrders,
  shouldDisplayDivisionColumn,
} from 'store/orderList/selectors'
import {
  getAppliedFilters,
  getSearchFilter,
} from 'store/orderListFilters/selectors'
import {
  setOrders,
  setSelectedOrderIds,
  setTargetOrderId,
} from 'store/orders/mergeOrders/actions'
import { setPageLoaderActive } from 'store/pageLoader/actions'

import { withRetailerCreatedOrders } from 'pages/OrderListPage/OrderListPage.queries'

import { withAnalytics } from './OrderList.analytics'
import OrderList from './OrderList.component'
import withPermissions from './OrderList.permissions'
import {
  withCheckMergingCriteria,
  withOrderExportTasks,
  withOrderSettings,
  withOrders,
  withOrdersDivisions,
  withOrdersStaticCounts,
  withOrdersTotals,
} from './OrderList.queries'
import {
  withBatchSetToReexportMutation,
  withEditEventsMutation,
} from './orderList.mutations'
import withOrderPaymentInfo from './withOrderPaymentInfo'
import withModal from 'containers/ModalHandler'

const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
  selectedOrdersIds: getSelectedOrdersIds(state),
  isOrderSelected: isOrderSelected(state),
  allOrdersAreSelected: allOrdersAreSelected(state),
  filterSelectedOrders: filterSelectedOrders(state),
  appliedFilters: getAppliedFilters(state),
  searchFilter: getSearchFilter(state),
  permissions: {
    allowSetToReExportOrder: isSetToReExportExportOrderAllowed(state),
    restrictAddEditEvents: isAddEditEventsRestricted(state),
    allowMarkOrderExported: isMarkOrderExportedAllowed(state),
    restrictCancelStyles: isCancelStylesRestricted(state),
    allowInvoiceRetailers: allowInvoiceRetailers(state),
    restrictMergeOrders: restrictMergeOrders(state),
  },
  orderBy: state.orderList.orderBy,
  canAssignOrdersToNewConnections: canAssignOrdersToNewConnections(state),
  accountId: getAccountId(state),
  destinationAccountId: toGlobalId('Account', getAccountId(state)),
  profileName: getAccountProfileName(state),
  isBrandUser: isAccountTypeBrand(state),
  isLiteRetailerUser: isLiteRetailer(state),
  pageSize: state.orderList.pageSize,
  isMergeOrderModalOpen: isMergeOrderModalOpen(state),
  mergeOrderMessages: mergeOrderMessages(state),
  shouldCheckMergeOrders: shouldCheckMergeOrders(state),
  shouldDisplayDivisionColumn: shouldDisplayDivisionColumn(state),
})

const mapDispatchToProps = (dispatch) => ({
  toggleOrder: (orderIds) => dispatch(toggleOrder(orderIds)),
  toggleSelectOrdersOnPage: (orderIds) =>
    dispatch(toggleSelectOrdersOnPage(orderIds)),
  handleResetSelectedOrders: () => dispatch(resetSelectedOrders()),
  setPageLoaderActive: (pageLoaderIsActive) =>
    dispatch(setPageLoaderActive(pageLoaderIsActive)),
  openModal: (modalName) => dispatch(setOrdersModal(modalName)),
  renderSuccessNotification: (message) =>
    dispatch(renderSuccessNotification(message)),
  renderErrorNotification: (message) =>
    dispatch(renderErrorNotification(message)),
  renderNotification: (message) => dispatch(renderNotification(message)),
  changePageSize: (pageSize) => dispatch(changePageSize(pageSize)),
  toggleMergeOrderModal: () => dispatch(toggleMergeOrderModal()),
  setMergeOrderMessages: (messages) =>
    dispatch(setMergeOrderMessages(messages)),
  setSelectedOrderIds: (selectedOrdersIds) =>
    dispatch(setSelectedOrderIds(selectedOrdersIds)),
  setTargetOrderId: (targetOrderId) =>
    dispatch(setTargetOrderId(targetOrderId)),
  setOrders: (orders) => dispatch(setOrders(orders)),
  toggleCheckMergeOrders: (toggle) => dispatch(toggleCheckMergeOrders(toggle)),
  toggleDisplayDivisionColumn: (toggle) =>
    dispatch(toggleDisplayDivisionColumn(toggle)),
})

const withRedux = connect(mapStateToProps, mapDispatchToProps)

export default compose(
  withLaunchDarkly,
  withRedux,
  withOrders,
  withOrdersDivisions,
  withOrdersTotals,
  withOrdersStaticCounts,
  withRetailerCreatedOrders,
  withOrderPaymentInfo,
  withEditEventsMutation,
  withBatchSetToReexportMutation,
  withModal,
  withMixpanel,
  withRouterCustom,
  withAnalytics,
  withPermissions,
  withConnectedProviders,
  withInvoicesStatus,
  withRenderToasters,
  withOrderSettings,
  withCheckMergingCriteria,
  withOrderExportTasks,
)(withLaunchDarkly(OrderList))
